import React, {useContext,useEffect,useState} from 'react'
import {Typography} from '@mui/material'
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import DOMPurify from 'dompurify';
import { formularioContext } from '../contextos/FormularioContext'
import { ArrowDownIcon } from '@heroicons/react/16/solid';
import Axios from 'axios'
import {ETVisualizarEventos} from './ETVisualizarEventos'
import Logo from './Logo'
import CircularProgress from '@mui/material/CircularProgress';
import {useParams} from 'react-router-dom'
import {useHelper} from '../hooks/useHelper';
import {ETError} from './ETError'
import {ETLoading} from './ETLoading'

// ... (tus imports se mantienen igual)

export const ETEventos = ({ esModoTest }) => {
    const { errorIntegrado, cargando } = useContext(formularioContext)
    const [eventos, setEventos] = useState([])
    const [loading, setLoading] = useState(true)
    const parametros = useParams()
    const { setToken } = useHelper();

    useEffect(() => {
        const obtenerEventos = async () => {
            try {
                setLoading(true)
                const rutaCondicional = esModoTest ? 'eventstest' : 'events'
                const { data } = await Axios.get(
                    process.env.NODE_ENV === 'development' 
                        ? `http://localhost:3020/documentos/${rutaCondicional}/all` 
                        : `https://uadapi.uad.digital/documentos/${rutaCondicional}/all`
                )
                setEventos(data)
                setLoading(false)
            } catch (err) {
                console.log('Error loading events', err)
                setLoading(false)
            }
        }
        obtenerEventos()
    }, [esModoTest])

    if (cargando) return <ETLoading />
    if (errorIntegrado) return <ETError />

    // Determinamos si debemos centrar todo el contenido
    const mostrarLista = !loading && eventos.length > 0;

    return (
        <div className={`flex flex-col items-center min-h-screen bg-white px-4 ${!mostrarLista ? 'justify-center' : 'pt-10'}`}>
            {/* El Logo y el Título ahora se moverán al centro si no hay eventos gracias al justify-center superior */}
            <Logo />
            
            <Typography 
                sx={{ 
                    marginTop: '1.5rem', 
                    marginBottom: mostrarLista ? '2rem' : '1rem' 
                }} 
                variant='h2'
            >
                Eventos
            </Typography>

            {loading ? (
                <CircularProgress />
            ) : eventos.length > 0 ? (
                /* Caso con eventos: se alinea arriba por la clase 'pt-10' */
                <div className="w-full max-w-6xl">
                    <ETVisualizarEventos
                        eventos={eventos}
                        eventoDefault={eventos.length === 1 ? eventos[0]?.id_evento : null}
                    />
                </div>
            ) : (
                /* Caso sin eventos: aparece justo debajo del título, todo centrado */
                <Typography 
                    variant="h6" 
                    sx={{ 
                        color: '#b91c1c', 
                        textAlign: 'center',
                        fontWeight: 400,
                        marginTop: '1rem'
                    }}
                >
                    No hay eventos habilitados en este momento
                </Typography>
            )}
        </div>
    )
}

